import ItemApi from '@apis/item/ItemApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { ItemResponse } from '@models/item';

const itemQueries = createQueryKeys('items', {
    list: (shopId: string, categoryId: string) => ({
        queryKey: [shopId, categoryId],
        queryFn: () => ItemApi.getItems(shopId, categoryId),
    }),
    detail: (itemId: string) => ({
        queryKey: [itemId],
        queryFn: async () => {
            // 옵션이 있는 옵션 그룹만 노출
            const { personalOptionGroups, defaultOptionGroups, ...rest } = await ItemApi.getItem(itemId);
            const data: ItemResponse = {
                ...rest,
                personalOptionGroups: personalOptionGroups.filter((it) => it.options.length > 0),
                defaultOptionGroups: defaultOptionGroups.filter((it) => it.options.length > 0),
            };
            return data;
        },
    }),
    nutrition: (itemId: string) => ({
        queryKey: [itemId, 'nutrition'],
        queryFn: () => ItemApi.getNutrition(itemId),
    }),
    shopItemFromShop: (shopId: string, itemId: string) => ({
        queryKey: ['fromShop', shopId, itemId],
        queryFn: () => ItemApi.getShopItemFromItemId(shopId, itemId),
    }),
});

export default itemQueries;
